import React from "react";
import PropTypes from "prop-types";
import styles from "./ChartWhiteboard.css";
import _Aux from "../../_Aux";
import AlertMessage from "../../Common/AlertMessage/AlertMessage";
import ChartHeader from "../ChartHeader/ChartHeader";
import ChartDrawing from "../ChartDrawing/ChartDrawing";
import ChartLegend from "../ChartLegend/ChartLegend";
import ChartFooter from "../ChartFooter/ChartFooter";

class ChartWhiteboard extends React.Component {
  componentDidMount() {
    var self = this;
    // SIA-93	Scrolling Issue for Add new Chart and Remove Chart
    if (self.props.whiteboardIndex !== 0) {
      setTimeout(function () {
        document.getElementById("ChartWhiteboardTitle" + self.props.whiteboardIndex).scrollIntoView();
      }, 0);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.whiteboard.__change_detection_key !== nextProps.whiteboard.__change_detection_key;
  }

  render() {
    // Whiteboard could have multiple chart drawings
    // Specially in case of Cost To Trade
    let chartDrawingsDoc = null;
    if (this.props.whiteboard.chartDrawings && this.props.whiteboard.chartDrawings.length) {
      chartDrawingsDoc = this.props.whiteboard.chartDrawings.map((drawingObj, index) => (
        <div
          key={drawingObj.__id}
          className={this.props.whiteboard.chartDrawings.length === 1 ? "grid__col-md-12 grid__col-sm-12" : "grid__col-md-6 grid__col-sm-6"}>
          <ChartDrawing
            key={drawingObj.__id}
            whiteboardIndex={this.props.whiteboardIndex}
            drawingIndex={index}
            drawing={drawingObj}
            isObsolete={this.props.whiteboard.isObsolete}
            drawingsLen={this.props.whiteboard.chartDrawings.length}
            selectedPrimaryChart={this.props.whiteboard.selectedPrimaryChart}
            selectedPrimaryChartType={this.props.whiteboard.selectedPrimaryChartType}
            selectedComparisonChart={this.props.whiteboard.selectedComparisonChart}
            selectedComparisonChartType={this.props.whiteboard.selectedComparisonChartType}
            selectedGranularity={this.props.whiteboard.selectedGranularity}
            selectedLayers={this.props.whiteboard.selectedLayers}
            selectedCostToTradeLotSizes={this.props.whiteboard.selectedCostToTradeLotSizes}
          />
        </div>
      ));
    } else {
      chartDrawingsDoc = (
        <div className={"grid__col-md-12 grid__col-sm-12 " + styles["chart-error-message-block"]}>
          <i className="fa fa-line-chart fa-5x" />
          <h3 className={styles["error-message"]}>No chart to display yet.</h3>
          <p className={styles["error-message"]}>
            Please choose the filter options above and then click <b>View Chart</b>
          </p>
        </div>
      );
    }

    let whiteboardTitleDoc = null;
    if (this.props.whiteboardIndex !== 0) {
      whiteboardTitleDoc = (
        <div id={"ChartWhiteboardTitle" + this.props.whiteboardIndex} className={"grid"}>
          <div className={"grid__col-md-12 grid__col-sm-12 "}>
            <h3 className={styles["second-chart-header"]}>Second Chart</h3>
          </div>
        </div>
      );
    }

    // Display individual loader for charts by whiteboard index
    const chartPreloader = (
      <div id={"chartPreloader-" + this.props.whiteboardIndex} className={styles["chart-preloader"]}>
        <p className={styles["icon"]}>
          <i className="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
        </p>
        <p id={"chartPreloaderText-" + this.props.whiteboardIndex} className={styles["chart-preloader-text"]}></p>
      </div>
    );

    return (
      <_Aux>
        <AlertMessage id={"whiteboardAlertError" + this.props.whiteboardIndex} whichAlert="error" />
        {whiteboardTitleDoc}
        <ChartHeader whiteboardIndex={this.props.whiteboardIndex} whiteboard={this.props.whiteboard} />
        <div className={styles["chart-whiteboard-component-container"]}>
          <div className={styles["chart-drawings-wrapper"]}>
            <div id={"chartWhiteboardDrawingDownload" + this.props.whiteboardIndex} className={"grid " + styles.chartWhiteboardDrawingDownload}>
              {this.props.whiteboard.isObsolete && this.props.whiteboard.chartDrawings.length ? (
                <div className={styles["outdated-overlay"]}>
                  <p>
                    It seems you have changed the filter options and therefore you must click <b>View Chart</b> to fetch new data and update the chart
                  </p>
                </div>
              ) : null}
              {chartPreloader}
              {chartDrawingsDoc}
            </div>
          </div>
        </div>
        <ChartFooter whiteboardIndex={this.props.whiteboardIndex} />
      </_Aux>
    );
  }
}

ChartWhiteboard.propTypes = {
  whiteboardIndex: PropTypes.number.isRequired,
  whiteboard: PropTypes.object.isRequired
};

export default ChartWhiteboard;



// WEBPACK FOOTER //
// ./src/components/Analytics/ChartWhiteboard/ChartWhiteboard.js